import clsx from 'clsx'

interface TooltipProps {
  content: string
  children: React.ReactNode
  className?: string
  position?: 'top' | 'bottom'
  tooltipClassName?: string
  hide?: boolean
  config?: {
    maxWidth?: string
    delay?: number
    allowHTML?: boolean
  }
}

export const Tooltip = ({
  content,
  children,
  className,
  position = 'top',
  tooltipClassName,
  hide,
  config,
}: TooltipProps) => {
  return (
    <div className={clsx('relative group inline-block', className)}>
      {children}
      <div
        className={clsx(
          'absolute left-1/2 -translate-x-1/2 py-[6px] px-2 bg-[#505050] rounded-lg shadow-lg z-[999] opacity-0 invisible  transition-opacity duration-200 text-wrap whitespace-pre-wrap w-max',
          !hide && 'group-hover:!opacity-100 group-hover:!visible',
          position === 'top' ? 'bottom-full mb-2' : 'top-full mt-2',
          tooltipClassName,
        )}
        style={{ maxWidth: config?.maxWidth }}
      >
        <div className="text-[#fff] text-sm font-Inter leading-5 text-left max-w-[200px] font-Inter">{content}</div>
      </div>
      {/* Arrow */}
      <div
        className={clsx(
          'absolute left-1/2 -translate-x-1/2  size-2 rounded-[1px] bg-[#505050] z-[1000] opacity-0 invisible  transition-opacity duration-200 shadow-lg',
          !hide && 'group-hover:!opacity-100 group-hover:!visible',
          position === 'top' ? 'bottom-[102%] mb-1 rotate-45' : 'top-[102%] mt-1 -rotate-45',
        )}
      />
    </div>
  )
}
